export const mixin = {
  data: () => ({
    fieldProps: {
      color: "primary",
      filled: true,
      height: "56px",
      hideDetails: true,
    },
  }),
};
